import React, { useCallback } from 'react';
import { TextV2, IconV2 } from '@withjoy/joykit';
import { Search } from '@withjoy/joykit/icons';

import { BannerWrapper, StyledBox, StyledLink } from './GuestBanner.styled';
import { useCreateWeddingTelemetry } from '@apps/createWedding/CreateWedding.telemetry';
import { useViewContext } from '../View';

export const GuestBanner: React.FC<{}> = () => {
  const findACoupleUrl = `${window.location.origin}/find`;

  const telemetry = useCreateWeddingTelemetry();

  const handleFindCouple = useCallback(() => {
    telemetry.findACoupleClicked();
  }, [telemetry]);

  const { currentView } = useViewContext();

  if (currentView !== 'createAccount') {
    return null;
  }

  return (
    <BannerWrapper backgroundColor="mono2" marginTop={0} alignItems="center" justifyContent="center">
      <TextV2 textAlign="center" as="p" fontWeight={600} typographyVariant="button1">
        Attending as a guest?
        <StyledBox as="span" paddingLeft={2}>
          <StyledLink textAlign="center" lineHeight="22px" fontSize={15} fontWeight={600} textDecoration="none" href={findACoupleUrl} onClick={handleFindCouple}>
            <IconV2 size={16} marginRight={1}>
              <Search size={16} />
            </IconV2>
            Find a Couple
          </StyledLink>
        </StyledBox>
      </TextV2>
    </BannerWrapper>
  );
};
